<!--订单详情页 折线图-->
<template>
    <div ref="myEchart" style="width:98%;height:98%" />
</template>
<script>
var echarts = require('echarts');
export default {
    data() {
        return {};
    },
    mounted() {
        this.dataEcharts();
    },
    methods: {
        dataEcharts() {
            this.chart = echarts.init(this.$refs.myEchart);
            this.chart.setOption({
                title: {
                    text: '充电期间状态',
                },
                tooltip: {
                    trigger: 'axis',
                },
                legend: {
                    data: ['功率', '电压', '电流', 'SOC(%)'],
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '8%',
                    containLabel: true,
                },
                toolbox: {
                    feature: {
                        saveAsImage: {},
                    },
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
                },
                yAxis: {
                    type: 'value',
                    show: true,
                    axisLine: {
                        show: true,
                    },
                },
                dataZoom: [
                    {
                        show: true,
                        realtime: true,
                        start: 0,
                        end: 50,
                        xAxisIndex: [0],
                        height: 20,
                        bottom: 4,
                    },
                    {
                        type: 'inside',
                        realtime: true,
                        start: 0,
                        end: 50,
                        xAxisIndex: [0],
                        height: 20,
                        bottom: 4,
                    },
                ],
                series: [
                    {
                        name: '功率',
                        type: 'line',
                        stack: '总量',
                        data: [220, 182, 191, 234, 290, 330, 310],
                    },
                    {
                        name: '电压',
                        type: 'line',
                        stack: '总量',
                        data: [150, 232, 201, 154, 190, 330, 410],
                    },
                    {
                        name: '电流',
                        type: 'line',
                        stack: '总量',
                        data: [320, 332, 301, 334, 390, 330, 320],
                    },
                    {
                        name: 'SOC(%)',
                        type: 'line',
                        stack: '总量',
                        data: [150, 232, 201, 154, 190, 330, 410],
                    },
                ],
            });
        },
    },
};
</script>
